import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import JBImage from 'components/essentials/JBImage';
import Cta from 'components/essentials/Cta/components/Cta';
import ProtectionPlanListItem from './ProtectionPlanListItem';

const ProtectionPlansItem = ({
  ctaButtonChildren,
  ctaId,
  icon,
  image,
  isLoading = false,
  isMostPopular = false,
  onClick = () => {},
  planDescription,
  planName,
  planPrice,
  showImages = false,
}) => (
  <button
    type="button"
    className={classNames(
      'relative rounded border-0 group/ProtectionPlansItem flex-1',
      {
        'mt-0.5 !bg-white': showImages,
        '!bg-gray-light8 md:!bg-white': !showImages,
      }
    )}
    onClick={!isLoading ? onClick : () => {}}
  >
    {showImages && !!image && (
      <JBImage
        alt=""
        className="rounded-tl rounded-tr h-auto w-full"
        crop="center"
        fit="crop"
        height="157"
        src={image}
        width="345"
      />
    )}

    {isMostPopular && (
      <div
        className={classNames(
          'text-xs absolute px-2 py-1 rounded-sm bg-[#f3ebd5] font-bold whitespace-nowrap text-center',
          {
            'top-2 left-2': showImages,
            'left-4 md:left-0 -top-2 md:-top-6': !showImages,
          }
        )}
      >
        Most Popular
      </div>
    )}

    <div
      className={classNames('relative min-h-[15rem] p-4 md:p-6', {
        'rounded-none border border-solid border-gray-light7 h-full bg-white m-4 md:bg-transparent md:m-0': !showImages,
      })}
    >
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h2 className="m-0 text-lg font-bold">{planName}</h2>

          <div className="text-lg font-bold text-left">
            ${Intl.NumberFormat().format(planPrice)}
          </div>
        </div>

        <div aria-hidden="true">{icon}</div>
      </div>

      <ul className="mx-0 my-3 min-h-[9rem]">
        {planDescription?.map(desc => (
          <ProtectionPlanListItem key={desc} desc={desc} />
        ))}
      </ul>

      <Cta
        as="span"
        block
        className="pointer-events-none border border-solid group-hover/ProtectionPlansItem:border-brand-dark"
        color="brand-light"
        data-xc={ctaId}
        disabled={isLoading}
        isLoading={isLoading}
        onClick={() => {}}
        styling="solid-button"
      >
        {ctaButtonChildren}
      </Cta>
    </div>
  </button>
);

ProtectionPlansItem.propTypes = {
  ctaButtonChildren: PropTypes.node,
  ctaId: PropTypes.string,
  icon: PropTypes.node,
  image: PropTypes.string,
  isLoading: PropTypes.bool,
  isMostPopular: PropTypes.bool,
  onClick: PropTypes.func,
  planDescription: PropTypes.arrayOf(PropTypes.string),
  planName: PropTypes.string,
  planPrice: PropTypes.number,
  showImages: PropTypes.bool,
};

export default ProtectionPlansItem;
